// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"p3-z","displaySixCardTiles":"q3-z"};